import React, {useEffect, useState} from "react";
import { navigate } from "gatsby";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { Select, MenuItem } from "@comfama/comfama-ui";
import CoursesCard from "../../molecules/courses-card/coursesCard";
import SearchBar from "../../atoms/search-bar/searchBar";
import Loading from "../../atoms/loading/loading";
import closeIcon from "../../../assets/images/icons/x.svg";
import arrowIcon from "../../../assets/images/icons/arrowiconback.svg";
import arrowLeft from "../../../assets/images/icons/flecha-izq.png";
// Services //
import axios from "axios";
import { getToken } from '../../../services/getToken';

import "./coursesFilter.scss"; 
import "../mentors-intern/mentorsIntern.scss"

const coursesFilter = (props: ReferenciaContenido) => {
    const [filteredInformation, setFilteredInformation] = useState<Array<any>>([]);
    const [cityInformation, setCityInformation] = useState<Array<Array<string>>>([]);
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [isOpenMenu, setIsOpenMenu] = useState<boolean>(false);
    const [isOpenModal, setIsOpenModal] = useState<boolean>(true);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [filterOption, setFilterOption] = useState({isActive: false, activeIndex: 999 });
    const [selectedOptions, setSelectedOptions] = useState<any[]>([]);
    const [offerNumber, setOfferNumber] = useState<number>(80);
    const [selectValue, setSelectValue] = useState<string>("");

    const offerUrl = process.env.AGW_EMPLEO_SERVICES_API_URL + "comfama/formaciones-api/api/v1/";

    const onChangeInput = (event, option) => {
        if(option === "Región"){
            setSelectedOptions(prevItems => prevItems.filter(item => item.option !== "Región"));
            setSelectedOptions(prevItems => [...prevItems, {name:event.name, option: option}]);
        } else {
            if (!selectedOptions.some(objeto => objeto.name === event.name)){
                setSelectedOptions(prevItems => [...prevItems, {name:event.name, option: option}]);
            } else {
                setSelectedOptions(prevItems => prevItems.filter(item => item.name !== event.name));
            }
        }
    };

    const onChangeSelect = (event) => {
        setSelectValue(event.target.value);
    }

    const handleContinueSelect = () => {
        setIsOpenModal(false);
        localStorage.setItem("modalOffer", "si");
        setSelectedOptions(prevItems => [...prevItems, {name:selectValue.split("*")[1], option: "Región"}]);
    }

    const cardCTA = (item) => {
        navigate("detalle/");
        localStorage.setItem("curso", JSON.stringify(item));
    };


    const apikeyServices = process.env.AGW_EMPLEO_SERVICES_API_KEY;
    const getLearningInformation = async () => {
            const token = await getToken();
            const headers = {
                Authorization: token.data.data.id_token,
                apikey: apikeyServices
            };
        axios.post(`${offerUrl}formaciones/filtered`,
            {
                "pageNumber":activeIndex+1,
                "region":selectedOptions.filter((element) => element?.option === "Región").length > 0 ? selectedOptions.filter((element) => element?.option === "Región")[0].name : '',
                "lugar":"",
                "duracionFormacion": selectedOptions.filter((element) => element?.option === "Duración").map((item) => parseInt(item.name.replace(" horas", ""))),
                "modalidad": selectedOptions.filter((element) => element?.option === "Modalidad").map((item) => item.name),
                "tipoFormacion": selectedOptions.filter((element) => element?.option === "Opciones de aprendizaje").map((item) => item.name),
                "rolFormativo":selectedOptions.filter((element) => element?.option === "Enfoque de aprendizaje").map((item) => item.name),
                "palabraClave": selectedOptions.filter((element) => element?.option === "palabraClave").length > 0 ? selectedOptions.filter((element) => element?.option === "palabraClave")[0].name : ''
            },{headers}).then(function (response) {
                setIsLoading(false);
                setOfferNumber(response?.data?.page?.totalElements);
                setFilteredInformation(response?.data?.content);
            })
            .catch(function (error) {
                console.error(error);
            }
        );
    }

    const restartPaginatorIndex = () => {
        activeIndex !== 0 && setActiveIndex(0);
    }

    const getCitiesInformation = async () => {
        const token = await getToken();
        const headers = {
            Authorization: token.data.data.id_token,
            apikey: apikeyServices
        };
        axios.get(`${offerUrl}region`, { headers })
        .then((response)=>{
            const cityArray: Array<Array<string>> = []
            response?.data.forEach((region)=>{
                region.municipios.forEach((municipio)=>{
                    cityArray.push([municipio.name, region.name]);
                })
            })
            setCityInformation(cityArray);
        })
        .catch((error)=>{
            console.error(error);
        })
    }

    const onClickClear = () => {
        setSelectedOptions([]);
        setFilterOption(prevState => ({
            ...prevState,
            isActive: false
        }))
        setIsOpenMenu(false);
    };

    useEffect (()=>{
        setIsLoading(true);
        getLearningInformation();
    },[selectedOptions, activeIndex]);

    useEffect (() => {
        restartPaginatorIndex();
    }, [selectedOptions])

    const getPages = () => {
        const pages: any = [];
        const delta = window.innerWidth >= 768 ? 2 : 1 ;

        const range = [
          1,
          ...Array.from({ length: delta * 2 + 1 }, (_, i) => activeIndex - delta + i).filter(
            (page) => page > 1 && page < Math.floor(offerNumber / 6)
          ),
          Math.floor(offerNumber / 6),
        ];

        let lastPage = 0;
        for (let page of range) {
          if (lastPage && page - lastPage !== 1) {
            pages.push('...');
          }
          pages.push(page);
          lastPage = page;
        }
        return pages;
    };

    useEffect (() => {
        const modalShowed = localStorage.getItem("modalOffer");
        if(modalShowed === "si"){
            setIsOpenModal(false);
        } else {
            getCitiesInformation();
        }
    },[])

    const onClickFilter: () => void = () => {
        const inputData: HTMLInputElement | null = document.querySelector('.a-search-bar__input');
        if(inputData?.value) {
            if (!selectedOptions.some(objeto => objeto.option === "palabraClave")){
                setSelectedOptions(prevItems => [...prevItems, {name:inputData?.value, option: "palabraClave"}]);
            } else {
                const newData = selectedOptions.map(item => 
                    item.option === "palabraClave" 
                        ? { ...item, name: inputData?.value } 
                        : item
                );
                setSelectedOptions(newData);
            }
        }
    }

    const enfoqueIndex: (index:number) => number = (index) => {
        if(selectedOptions.filter((element) => element?.option === "Región")[0]){
            if(selectedOptions.filter((element) => element?.option === "Región")[0].name === "Medellín y área metropolitana"){
                return index;
            } else {
                return index + 1;
            }
        }
        return 0;
    }

    return (
        <div className="o-curses-filter">
            <SearchBar styles={{gridArea: "search"}} callToAction={onClickFilter} />
            <section className="o-curses-filter__filter">
                {window.innerWidth >= 768 ?
                    <>
                        {props.referenciaPlantillaContenido.map((option, index) => {
                            if(option.tituloBanner === "Enfoque de aprendizaje"){
                                if(selectedOptions.filter((element) => element?.option === "Región").length > 0){
                                    return (
                                        <div key={`filer-option-${index}}`} className="o-curses-filter__filter--desktop">
                                            <button 
                                                className="o-curses-filter__filter-option--desktop" 
                                                onClick={() => 
                                                    setFilterOption({isActive: filterOption.activeIndex === index ? false : true, activeIndex: filterOption.activeIndex === index ? 999 : index})
                                                }
                                            >
                                                <span>Enfoque de aprendizaje</span>
                                                <img alt="Ícono flecha a la derecha." src={arrowIcon} className={`${filterOption.isActive && filterOption.activeIndex === index ? "top" : "bottom"}`}/>
                                            </button>
                                            <div className="o-curses-filter__filter-desktop-container">
                                                {filterOption.isActive && filterOption.activeIndex === index &&
                                                    props.referenciaPlantillaContenido[enfoqueIndex(index)].referenciaContenido.map((referOption, referIndex) => 
                                                        <label key={`filter-item-${referIndex}`} className="o-curses-filter__filter-option-label">
                                                            <input
                                                                type={props.referenciaPlantillaContenido[index].tipoTitulo === "Check" ? "radio" : "checkbox"}
                                                                className={props.referenciaPlantillaContenido[index].tipoTitulo === "Check" ? "o-curses-filter__filter-option-radio" :"o-curses-filter__filter-option-checkbox"}
                                                                name={referOption.tituloBanner}
                                                                checked={selectedOptions.some(objeto => objeto.name === referOption.tituloBanner)}
                                                                onClick={e => onChangeInput(e.target, "Enfoque de aprendizaje")}
                                                            />
                                                            <span className={selectedOptions.some(objeto => objeto.name === referOption.tituloBanner) ? "o-curses-filter__filter-option-number--active" : ""}>{referOption.tituloBanner}</span>
                                                        </label>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    );
                                }
                            } else if(option.tituloBanner === "Enfoque de aprendizaje regiones"){
                                return null;
                            } else {
                                return (
                                    <div key={`filer-option-${index}}`} className="o-curses-filter__filter--desktop">
                                        <button 
                                            className="o-curses-filter__filter-option--desktop" 
                                            onClick={() => 
                                                setFilterOption({isActive: filterOption.activeIndex === index ? false : true, activeIndex: filterOption.activeIndex === index ? 999 : index})
                                            }
                                        >
                                            <span>{option.tituloBanner}</span>
                                            <img alt="Ícono flecha a la derecha." src={arrowIcon} className={`${filterOption.isActive && filterOption.activeIndex === index ? "top" : "bottom"}`}/>
                                        </button>
                                        <div className="o-curses-filter__filter-desktop-container">
                                            {filterOption.isActive && filterOption.activeIndex === index &&
                                                props.referenciaPlantillaContenido[index].referenciaContenido.map((referOption, referIndex) => 
                                                    <label key={`filter-item-${referIndex}`} className="o-curses-filter__filter-option-label">
                                                        <input
                                                            type={props.referenciaPlantillaContenido[index].tipoTitulo === "Check" ? "radio" : "checkbox"}
                                                            className={props.referenciaPlantillaContenido[index].tipoTitulo === "Check" ? "o-curses-filter__filter-option-radio" :"o-curses-filter__filter-option-checkbox"}
                                                            name={referOption.tituloBanner}
                                                            checked={selectedOptions.some(objeto => objeto.name === referOption.tituloBanner)}
                                                            onClick={e => onChangeInput(e.target, props.referenciaPlantillaContenido[filterOption.activeIndex].tituloBanner)}
                                                        />
                                                        <span className={selectedOptions.some(objeto => objeto.name === referOption.tituloBanner) ? "o-curses-filter__filter-option-number--active" : ""}>{referOption.tituloBanner}</span>
                                                    </label>
                                                )
                                            }
                                        </div>
                                    </div>
                                );
                            }
                        })}
                    </>
                :
                    <button className="o-curses-filter__filter-button" onClick={() => setIsOpenMenu(true)}>
                        FILTRAR POR:
                    </button>
                }
            </section>
            <span className="o-curses-filter__filter-count"><strong className="o-curses-filter__filter-counter">{offerNumber}</strong>Formaciones disponibles</span>
                <div className="o-curses-filter__label-container">
                    {window.innerWidth >= 768 &&
                        <div className="o-curses-filter__label-container-title">
                            <span>Filtros:</span>
                            <button onClick={onClickClear} className="o-curses-filter__label-container-button">
                                LIMPIAR
                            </button>
                        </div>
                    }
                    {selectedOptions.map((option) => {
                        return (
                            <div className="o-curses-filter__label">
                                <span>{option.name}</span>
                                <button onClick={() => {setSelectedOptions(prevItems => prevItems.filter(item => item.name !== option.name));}}>
                                    <img alt="Icono de cerrar" src={closeIcon} />
                                </button>
                            </div>
                        );
                    })}
                </div>
            <div className="o-curses-filter__card-container">
                {isLoading ? 
                        <>
                            <div></div>
                            <Loading />
                        </>
                    :
                    <>
                        {filteredInformation && filteredInformation?.map((card)=> {
                            return (
                                <CoursesCard
                                    tittle={card.portafolio}
                                    description={card.objetivo}
                                    location={card?.lugar ? card?.lugar : "Todas"}
                                    duration={card.duracion}
                                    modality={card?.modalidad ? card?.modalidad : "Virtual"}
                                    categoriaMultimedia={card.tipo_formacion}
                                    callToAction={() => cardCTA(card)}
                                    image={card.foto_desktop.includes(" ^ ") ? card.foto_desktop.split(" ^ ")[0] : card.foto_desktop}
                                    mobileImage={card.foto_mobile.includes(" ^ ") ? card.foto_mobile.split(" ^ ")[0] : card.foto_mobile}
                                />
                            );
                        })}
                    </>}
            </div>
            {filteredInformation && Math.floor(offerNumber / 6) > 0 && 
                <div className="o-mentors-intern__paginator o-curses-filter__paginator">
                    <button 
                        onClick={() => {setActiveIndex(activeIndex-1)}}
                        disabled={activeIndex === 0}
                        className="o-mentors-intern__paginator-button"
                    >
                        Atrás
                    </button>
                    {getPages().map((page, index) => (
                        <button
                            key={index}
                            disabled={page === '...' || activeIndex===index}
                            onClick={() => page !== '...' && setActiveIndex(index)}
                            className="o-mentors-intern__paginator-button"
                        >
                            {page}
                        </button>
                    ))}
                    <button 
                        onClick={() => {setActiveIndex(activeIndex+1)}}
                        disabled={activeIndex === Math.floor(offerNumber / 6)}
                        className="o-mentors-intern__paginator-button"
                    >
                        Siguiente
                    </button>
                </div>
            }
            <section className="o-curses-filter__banner">
                <div>
                    <img
                        className="o-curses-filter__banner-img"
                        src="https://images.ctfassets.net/203frbsx1z3n/5QNv4iqAgchLAsFBPw3sdT/b7fdfbec4a440f9c433e5d31560909a8/Banner_subsidio_al_desempleo.jpg" 
                        alt="imagen ilustrativa curso"
                    />
                    <div className="o-curses-filter__banner-info-container">
                        <p className="o-curses-filter__banner-title">Subsidio al Desempleo</p>
                        <p className="o-curses-filter__banner-description">Asistiendo a nuestros cursos estarás cumpliendo con uno de los requisitos para aplicar al subsidio.</p>
                    </div>
                    <button className="o-curses-filter__banner-button" onClick={() => navigate("/personas/subsidio-de-desempleo/")}>MÁS INFORMACIÓN</button>
                </div>
            </section>

            {isOpenMenu && (
                <div className="m-number-steps__modal">
                    <div className="m-number-steps__modal-content">
                        <div className={`o-curses-filter__filter-menu ${isOpenMenu ? "showMenu" : "hideMenu"}`}>
                            <div className="o-curses-filter__filter-menu-header">
                                {filterOption.isActive && 
                                    <button className="o-curses-filter__filter-menu-header-back" onClick={() => setFilterOption(prevState => ({
                                        ...prevState,
                                        isActive: false
                                    }))
                                    }>
                                        <img alt="Flecha volver" src={arrowLeft}/>
                                    </button>
                                }
                                <h3>{filterOption.isActive ? props.referenciaPlantillaContenido[filterOption.activeIndex].tituloBanner.toUpperCase() : "FILTRAR POR:"}</h3>
                                <button 
                                    className="o-curses-filter__filter-menu-header-close" 
                                    onClick={() => {
                                        setIsOpenMenu(false);
                                        setSelectedOptions([]);
                                        setFilterOption(prevState => ({
                                            ...prevState,
                                            isActive: false
                                        }))
                                    }}
                                >
                                    <img alt="Icono de cerrar" src={closeIcon} />
                                </button>
                            </div>
                            <div className="o-curses-filter__filter-option-container">
                                {props.referenciaPlantillaContenido.map((option, index) => {
                                    if(option.tituloBanner === "Enfoque de aprendizaje"){
                                        if(selectedOptions.filter((element) => element?.option === "Región").length > 0){
                                            return (
                                                <button
                                                    key={`filer-option-${index}}`}
                                                    className="o-curses-filter__filter-option"
                                                    onClick={() => setFilterOption({isActive: true, activeIndex: index})}
                                                >
                                                    <span>{option.tituloBanner}</span>
                                                    <img alt="Ícono flecha a la derecha." src={arrowIcon}/>
                                                </button>
                                            );
                                        }                               
                                    } else if(option.tituloBanner === "Enfoque de aprendizaje regiones"){
                                        return null;
                                    }
                                    else{
                                        return (
                                            <button
                                                key={`filer-option-${index}}`}
                                                className="o-curses-filter__filter-option"
                                                onClick={() => setFilterOption({isActive: true, activeIndex: index})}
                                            >
                                                <span>{option.tituloBanner}</span>
                                                <img alt="Ícono flecha a la derecha." src={arrowIcon}/>
                                            </button>
                                        );
                                    }
                                })}
                            </div>
                            {filterOption.isActive &&
                            <div className={`o-curses-filter__filter-option-selector ${filterOption.isActive ? "showMenu" : "hideMenu" }`}>
                                {props.referenciaPlantillaContenido[filterOption.activeIndex === 1 ? enfoqueIndex(filterOption.activeIndex) : filterOption.activeIndex].referenciaContenido.map((option, index) => 
                                    <label key={`filter-item-${index}`} className="o-curses-filter__filter-option-label">
                                        <input
                                            type={props.referenciaPlantillaContenido[filterOption.activeIndex].tipoTitulo === "Check" ? "radio" : "checkbox"}
                                            className={props.referenciaPlantillaContenido[filterOption.activeIndex].tipoTitulo === "Check" ? "o-curses-filter__filter-option-radio" :"o-curses-filter__filter-option-checkbox"}
                                            name={option.tituloBanner}
                                            onChange={e => onChangeInput(e.target, props.referenciaPlantillaContenido[filterOption.activeIndex].tituloBanner)}
                                            checked={selectedOptions.some(objeto => objeto.name === option.tituloBanner)}
                                        />
                                        <span className={selectedOptions.some(objeto => objeto.name === option.tituloBanner) ? "o-curses-filter__filter-option-number--active" : ""}>{option.tituloBanner}</span>
                                    </label>
                                )}
                            </div>}
                            <div className="o-curses-filter__filter-button-container">
                                <button onClick={onClickClear}>
                                    LIMPIAR
                                </button>
                                <button
                                    onClick={() => {
                                        setFilterOption(prevState => ({
                                            ...prevState,
                                            isActive: false
                                        }))
                                        setIsOpenMenu(false);
                                    }}
                                >
                                    FILTRAR
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {isOpenModal && (
            <div className="m-number-steps__modal">
                <div className="m-number-steps__modal-content">
                    <div className="o-curses-filter__modal">
                        <h2 className="o-curses-filter__modal-title">¿Dónde te encuentras?</h2>
                        <p className="o-curses-filter__modal-label">Selecciona donde te ubicas para presentarte la oferta de tu región.</p>
                        <Select
                            fullWidth
                            displayEmpty
                            value={selectValue} 
                            onChange={onChangeSelect}
                        >
                            <MenuItem disabled value="">Selecciona</MenuItem>
                            {cityInformation.map((city)=><MenuItem value={`${city[0]}*${city[1]}`}>{city[0]}</MenuItem>)}
                        </Select>
                        <button 
                            className="o-curses-filter__modal-button"
                            onClick={()=> {
                                handleContinueSelect();
                            }}
                        >
                            CONTINUAR
                        </button>
                    </div>
                </div>
            </div>
            )}
        </div>
    );
};

export default coursesFilter;

